import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _OpenEntry;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { IconButton } from '@instructure/ui-buttons';
import { IconQuestionLine } from '@instructure/ui-icons';
import { SimpleModal, SimpleSelect } from '@instructure/quiz-common';
import { toErrors } from '../../../../../../util/instUIMessages';
import SpecifiedAnswers from '../../blank_type_options/SpecifiedAnswers';
import RegexComponent from '../../blank_type_options/RegexComponent';
import EditDistance from '../../blank_type_options/EditDistance';
import TipInfo from '../TipInfo';
import t from '@instructure/quiz-i18n/format-message';
import { View } from '@instructure/ui-view';
var OpenEntry = /*#__PURE__*/function (_Component) {
  function OpenEntry() {
    var _this2;
    _classCallCheck(this, OpenEntry);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, OpenEntry, [].concat(args));
    _defineProperty(_this2, "state", {
      isModalOpen: false
    });
    _defineProperty(_this2, "containerRef", null);
    _defineProperty(_this2, "triggerRef", null);
    _defineProperty(_this2, "handleContainerRef", function (el) {
      _this2.containerRef = el;
    });
    _defineProperty(_this2, "handleTriggerRef", function (el) {
      _this2.triggerRef = el;
    });
    _defineProperty(_this2, "handleCloseModal", function () {
      _this2.setState({
        isModalOpen: false
      });
    });
    _defineProperty(_this2, "handleOpenModal", function () {
      _this2.setState({
        isModalOpen: true
      });
    });
    return _this2;
  }
  _inherits(OpenEntry, _Component);
  return _createClass(OpenEntry, [{
    key: "renderTextMatch",
    value: function renderTextMatch(TextMatchComponent) {
      return jsx(TextMatchComponent, {
        validationErrorsFromApi: this.props.validationErrorsFromApi,
        errors: this.textMatchErrors(),
        notifyScreenreader: this.props.notifyScreenreader,
        scoringDataForBlank: this.props.blankScoringData,
        updateScoringDataForBlank: this.props.updateBlankScoringData
      });
    }
  }, {
    key: "textMatchErrors",
    value: function textMatchErrors() {
      switch (this.props.blankScoringAlgorithm) {
        case 'TextInChoices':
          return this.props.scoringDataErrors.value || {};
        case 'TextRegex':
          return (this.props.scoringDataErrors.value || {}).$errors || [];
        case 'TextCloseEnough':
          return this.props.scoringDataErrors.editDistance || [];
        default:
          return [];
      }
    }
  }, {
    key: "textMatchSelectErrors",
    value: function textMatchSelectErrors() {
      switch (this.props.blankScoringAlgorithm) {
        case 'TextContainsAnswer':
        case 'TextEquivalence':
          return (this.props.scoringDataErrors.value || {}).$errors || [];
        default:
          return [];
      }
    }
  }, {
    key: "renderTextMatchOptions",
    value: function renderTextMatchOptions() {
      switch (this.props.blankScoringAlgorithm) {
        case 'TextInChoices':
          return this.renderTextMatch(SpecifiedAnswers);
        case 'TextRegex':
          return this.renderTextMatch(RegexComponent);
        case 'TextCloseEnough':
          return this.renderTextMatch(EditDistance);
        default:
      }
    }
  }, {
    key: "renderOpenEntryOptions",
    value: function renderOpenEntryOptions() {
      var blankText = this.props.blankScoringData.blankText;
      var options = [{
        id: 'open-entry-select-option-contains',
        value: 'TextContainsAnswer',
        text: t('Contains "{blankText}"', {
          blankText: blankText
        })
      }, {
        id: 'open-entry-select-option-close-enough',
        value: 'TextCloseEnough',
        text: t('Close Enough')
      }, {
        id: 'open-entry-select-option-exact-match',
        value: 'TextEquivalence',
        text: t('Exact Match')
      }, {
        id: 'open-entry-select-option-text-in-choices',
        value: 'TextInChoices',
        text: t('Specify Correct Answers')
      }, {
        id: 'open-entry-select-option-regex',
        value: 'TextRegex',
        text: t('Regular Expression Match')
      }];
      return options.map(function (option) {
        return jsx(SimpleSelect.Option, {
          key: option.value,
          id: option.id,
          value: option.value
        }, option.text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(View, {
        position: "relative",
        as: "div"
      }, jsx(View, {
        position: "absolute",
        insetBlockStart: "-5px",
        insetInlineEnd: "0",
        ref: this.handleContainerRef
      }, jsx(IconButton, {
        onClick: this.handleOpenModal,
        size: "small",
        themeOverride: {
          borderRadius: '50%',
          smallPadding: 'none'
        },
        renderIcon: IconQuestionLine,
        withBackground: false,
        withBorder: false,
        screenReaderLabel: t('Text Match Help')
      })), jsx(SimpleSelect, {
        key: this.props.blankScoringData.blankText,
        renderLabel: t('Text Match'),
        onChange: this.props.updateBlankTextMatch,
        value: this.props.blankScoringAlgorithm,
        messages: toErrors(this.textMatchSelectErrors())
      }, this.renderOpenEntryOptions()), this.renderTextMatchOptions(), jsx(SimpleModal, {
        size: "small",
        title: t('Text Match Options'),
        label: t('Text Match Options'),
        isModalOpen: this.state.isModalOpen,
        onModalDismiss: this.handleCloseModal
      }, jsx(TipInfo, null)));
    }
  }]);
}(Component);
_OpenEntry = OpenEntry;
_defineProperty(OpenEntry, "displayName", 'OpenEntry');
_defineProperty(OpenEntry, "componentId", "Quizzes".concat(_OpenEntry.displayName));
_defineProperty(OpenEntry, "propTypes", {
  blankScoringAlgorithm: PropTypes.string,
  blankScoringData: PropTypes.object,
  notifyScreenreader: PropTypes.func.isRequired,
  scoringDataErrors: PropTypes.object,
  updateBlankScoringData: PropTypes.func,
  updateBlankTextMatch: PropTypes.func,
  validationErrorsFromApi: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string
  })),
  styles: PropTypes.object
});
_defineProperty(OpenEntry, "defaultProps", {
  scoringDataErrors: {},
  blankScoringAlgorithm: void 0,
  blankScoringData: void 0,
  updateBlankScoringData: void 0,
  updateBlankTextMatch: void 0,
  validationErrorsFromApi: []
});
export { OpenEntry as default };